export type CancellationReason = {
  code: string
  description: string
}

export const CANCELLATION_REASONS: CancellationReason[] = [
  { code: 'expv', description: 'Too expensive' },
  { code: 'movn', description: 'No problem, just moving on' },
  { code: 'mvvd', description: 'Problems with the movies/videos' },
  { code: 'nacs', description: 'I could not get in to the site' },
  { code: 'nlik', description: "Didn't like the site" },
  { code: 'none', description: 'No cancel reason provided' },
  { code: 'ntme', description: 'I did not do it or do not recognize the transaction' },
  { code: 'slow', description: 'Site was too slow' },
  { code: 'stal', description: 'Not enough updates' },
  { code: 'tech', description: 'The site did not work' },
  { code: 'usfm', description: 'Un-authorised Signup by Family Member' },
  { code: 'wmrq', description: 'Webmaster Requested to Cancel' },
]

export const getCancellationDescription = (code: string): string => {
  const reason = CANCELLATION_REASONS.find((r) => r.code === code)
  return reason?.description || 'Unknown reason'
}
